/* ──────────────────────────────────────────────────────────────────────
   Publisher categorisation — DB-driven.

   We no longer guess. Categories come from the authoritative dimension
   table `dbo.Category` (Regional / Mainline / Financial / Periodical),
   denormalised onto `crawler.EditionMaster_Crawler` by sql/007 and
   surfaced on /api/publishers as `category` / `category_id`.

   This module only owns presentation order, labels and short codes for
   filter chips. No regex, no defaulting.

   See `audit_catalog_full.py` + sql/007 + backfill_catalog_review.py for
   how the data got here.
   ────────────────────────────────────────────────────────────────────── */

export type Category =
  | "all"
  | "regional"
  | "mainline"
  | "financial"
  | "periodical";

export const CATEGORY_LABEL: Record<Category, string> = {
  all:        "All",
  regional:   "Regional",
  mainline:   "Mainline",
  financial:  "Financial",
  periodical: "Periodical",
};

export const CATEGORY_ORDER: ReadonlyArray<Category> = [
  "all", "mainline", "financial", "regional", "periodical",
];

/** Coerce an API-supplied category string (or null) to the typed key. */
export function categoryKey(apiCategory: string | null | undefined): Exclude<Category, "all"> | null {
  if (!apiCategory) return null;
  const k = apiCategory.toLowerCase();
  if (k === "regional" || k === "mainline" || k === "financial" || k === "periodical") {
    return k;
  }
  return null;
}
